module.exports = __webpack_public_path__ + "static/media/religious.e07078b4.png";